/**
 * Throws if !response.ok with given string or response.json().detail
 * @param response a response
 * @param genericMsg a fallback message, if json.detail is missing
 * @returns untouched response if ok, errors out otherwise
 */
export const errorIfInvalidResponse = async (
  response: Response,
  genericMsg = 'Ooops... something went wrong.',
) => {
  if (!response.ok) {
    let msg
    try {
      const json = await response.json()
      const { detail } = json
      if (detail) {
        if (detail.message) {
          msg = detail.message
        } else {
          // why ".msg", is it part of connector schema?
          msg = Array.isArray(detail) ? detail[0].msg : detail
        }
      }
    } catch (err: any) {
      // eslint-disable-next-line
    }
    throw new Error(msg || genericMsg)
  }
  return response
}
